/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The processing status of a Guesty event
 */
export type GuestyEventStatus = 'PENDING' | 'PROCESSED' | 'ERROR';

export const GuestyEventStatus = {
    PENDING: 'PENDING' as GuestyEventStatus,
    PROCESSED: 'PROCESSED' as GuestyEventStatus,
    ERROR: 'ERROR' as GuestyEventStatus
};

